import { create } from "zustand";

export const useLeaveHistoryStore = create((set) => ({
  loading: false,
  error: null,

  fetchLeaveHistory: async ({
    accessToken,
    companyId,
    selectedYear,
    hasManagedPermission,
    hasAllPermission,
  }) => {
    try {
      set({ loading: true, error: null });

      let apiUrl = "";

      if (hasManagedPermission) {
        apiUrl = `${process.env.REACT_APP_BASE_URL}/employees/leave/history`;
      }

      if (hasAllPermission) {
        apiUrl = `${process.env.REACT_APP_BASE_URL}/employees/leave/history?company_id=${companyId}&year=${selectedYear}`;
      }

      if (!apiUrl) throw new Error("No permission to download");

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download leave history");
      }

      // ✅ Get Excel file as blob
      const blob = await response.blob();

      // ✅ Create download link
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      // filename
      a.download = `leave-history-${selectedYear}.xlsx`;

      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      set({ loading: false });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },
}));
